export enum FacilityTypeEnum {
  MANUFACTURING = 1,
  WAREHOUSE = 2,
  RETAIL = 3,
  OTHER = 4
}

export namespace FacilityTypeEnum {
  export function getClassName(): string {
    return 'FacilityTypeEnum';
  }
}
